// extracted by mini-css-extract-plugin
export var borderRadius = "_9c-4";
export var large = "_9c-3";
export var logoContainer = "_9c-0";
export var nameLogo = "_9c-2";
export var small = "_9c-1";